export default __webpack_public_path__ + "static/media/google_icon.5ca3a510.svg";